<script setup lang="ts">
import LawyerCardExperience from '@/widgets/LawyerCard/ui/LawyerCardExperience.vue';
import type { IInfoNameProps } from '@/widgets/LawyerCard/model/types/lawyerCard';

withDefaults(defineProps<IInfoNameProps>(), {
  isLawyerPage: false,
  isCatalog: false,
  isCardSlider: false,
  isLawyerCompanyCard: false,
  isArticle: false,
});

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div
    :class="[
      'info-name',
      { _mobile: isMobile },
      { _catalog: isCatalog },
      { _slider: isCardSlider },
      { _lawyer: isLawyerPage },
      { _article: isArticle },
      { '_is-lawyer-company': isLawyerCompanyCard },
    ]"
  >
    <template v-if="isLawyerPage">
      <h1 class="info-name__title">
        {{ name }}
      </h1>
    </template>
    <template v-else>
      <span v-if="isLawyerCompanyCard" class="info-name__title">
        {{ name }}
      </span>
      <NuxtLink v-else class="info-name__link" :to="linkToProfileCatalog">
        <h2 class="info-name__title">
          {{ name }}
        </h2>
      </NuxtLink>
      <div
        v-if="(isArticle || isLawyerCompanyCard) && !isCatalog && !isCardSlider"
        class="info-name__experience"
      >
        <LawyerCardExperience
          :is-article="isArticle"
          :is-lawyer-company-card="isLawyerCompanyCard"
        />
      </div>
    </template>
  </div>
</template>

<style lang="less">
.info-name {
  &__link {
    .color-change-hover();

    display: block;
  }

  &__title {
    display: flex;
    font-weight: 700;
    font-size: 18px;
    line-height: @size-x6;
    max-width: calc(100% - 50px);
  }

  &__experience {
    font-size: @size-x3;
    line-height: @size-x4;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    margin-top: @main-size;
  }

  &._catalog &__title {
    cursor: pointer;
  }

  &._article &__title {
    font-size: @size-x4;
    line-height: 21px;
  }

  &._is-lawyer-company &__title {
    .color-change-hover();

    max-width: 137px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    cursor: pointer;

    br {
      display: none;
    }
  }

  &._lawyer &__title {
    max-width: calc(100% - 76px);
  }

  &._slider &__title {
    max-width: calc(100% - @size-x9);
  }

  &._mobile &__title {
    font-weight: 600;
    font-size: @size-x4;
    line-height: 21px;
    max-width: calc(100% - 48px);
  }

  &._mobile._lawyer &__title br {
    display: block;
  }

  &._mobile._slider &__title {
    max-width: 75%;
    margin: 0;
  }

  &._is-lawyer-company &__title {
    margin: 0 auto;
    max-width: 100%;
  }
}
</style>
